import React from 'react';
import GridMenuButton from '@components-clean/core/grid/grid-menu/grid-menu-button';

export interface GridViewMenuItem {
    label: string;
    onClick: () => void;
    isActive: boolean;
    isDisabled?: boolean;
    isHidden?: boolean;
    icon?: React.ReactNode;
}

interface GridViewMenuProps {
    viewOptions: GridViewMenuItem[];
    closeMenu?: () => void;
}

const GridViewMenu = ({ viewOptions, closeMenu }: GridViewMenuProps) => {
    const handleMenuItemClick = (item: GridViewMenuItem) => {
        item.onClick();
        if (closeMenu) {
            closeMenu();
        }
    };

    return (
        <div>
            {viewOptions.map((item) => (
                <GridMenuButton key={item.label} item={item} onClick={handleMenuItemClick} />
            ))}
        </div>
    );
};

export default GridViewMenu;
